import React, { useState } from 'react'
import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { useFetch } from 'use-http'
import { MAIN_API_URL } from '../../../configuration'
import { useParams } from 'react-router-dom'
import { Alert } from '@/components/ui'

const validationSchema = Yup.object({
    mail: Yup.string().email('Ingrese un correo electrónico válido').required('El correo electrónico es requerido'),
});

export const UserPasswordResendEmail = () => {
    const { post, loading, response } = useFetch(MAIN_API_URL);
    const params = useParams();

    const [msg, setMsg] = useState({
        type: '',
        text: '',
    });

    const formik = useFormik({
        initialValues: {
            mail: params.mail,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.mail = values.mail.toLowerCase().trim();
            const data = await post('/auth/request-password-reset', values)
            if (response.ok) {
                setMsg({
                    type: 'success',
                    text: data
                })
                setTimeout(() => {
                    window.location.reload();
                }, 3000)
            } else {
                setMsg({
                    type: 'error',
                    text: data.msg
                })
            }
        }
    })
    return (
        <>
            <LoadingButton
                variant="contained"
                loadingPosition="center"
                loading={loading}
                disabled={loading}
                loadingIndicator="Cargando..."
                sx={{
                    width: '100%',
                    height: '48px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    color: '#fff',
                    background: '#0DA15A',
                    boxShadow: '0 1px 2px rgba(13,161,90,.25), 0 6px 16px -6px rgba(13,161,90,.45)',
                    '&:hover': {
                        background: '#0A8449',
                        boxShadow: '0 2px 4px rgba(13,161,90,.3), 0 10px 22px -8px rgba(13,161,90,.5)',
                    },
                    '&.Mui-disabled': {
                        background: '#0DA15A',
                        color: '#fff',
                        opacity: 0.6,
                    },
                }}
                onClick={formik.handleSubmit}
            >
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.95rem', fontWeight: 600 }}>
                    Reenviar email
                </Typography>
            </LoadingButton>
            {
                msg.type && (
                    <Alert variant={msg.type === 'success' ? 'success' : 'danger'} className="w-full text-left py-2.5 px-3 text-[13px]">
                        {msg.text}
                    </Alert>
                )
            }
            <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                textAlign={'left'}
                gap={1}
            >
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--muted-foreground)', marginBottom: '0.5rem' }}>
                    Tené en cuenta los siguientes puntos antes de reenviar el email:
                </Typography>
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.7rem', fontWeight: 500, color: 'var(--muted-foreground)' }}>
                    1. Verificá que el email ingresado sea el correcto.
                </Typography>
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.7rem', fontWeight: 500, color: 'var(--muted-foreground)' }}>
                    2. En algunos casos el proveedor de envíos de correos electrónicos puede demorar hasta 5 minutos en enviar el email.
                </Typography>
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.7rem', fontWeight: 500, color: 'var(--muted-foreground)' }}>
                    3. Verificá que el correo no esté en la carpeta de Promociones o Spam.
                </Typography>
            </Box>

        </>
    )
}
